"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConceptMaterialUtil = void 0;
const types_1 = require("../main/types");
const ConceptMaterial_1 = require("./ConceptMaterial");
const LanguageConceptMaterial_1 = require("./LanguageConceptMaterial");
const SignLanguageConceptMaterial_1 = require("./SignLanguageConceptMaterial");
const GameplayUtil_1 = require("../main/types/gameplays/GameplayUtil");
class ConceptMaterialUtil {
    static getConverter(category) {
        switch (category) {
            case types_1.ConceptMaterialCategory.Language:
                return LanguageConceptMaterial_1.LanguageConceptMaterial.converter;
            case types_1.ConceptMaterialCategory.SignLanguage:
                return SignLanguageConceptMaterial_1.SignLanguageConceptMaterial.converter;
            default:
                return ConceptMaterial_1.ConceptMaterial.converter;
        }
    }
    static getAlgoliaConverterFunc(category) {
        switch (category) {
            case types_1.ConceptMaterialCategory.Language:
                return LanguageConceptMaterial_1.LanguageConceptMaterial.fromAlgolia;
            case types_1.ConceptMaterialCategory.SignLanguage:
                return SignLanguageConceptMaterial_1.SignLanguageConceptMaterial.fromAlgolia;
            default:
                return ConceptMaterial_1.ConceptMaterial.fromAlgolia;
        }
    }
    static getSupportedGameplays(conceptMaterial) {
        function isNumber(value) {
            let sanitized = value;
            if (typeof sanitized === "string") {
                sanitized = sanitized.replace(/,/g, "");
            }
            if (Number(sanitized)) {
                return true;
            }
            else {
                return false;
            }
        }
        const materialCategory = conceptMaterial.materialCategory;
        const gameplays = [];
        switch (materialCategory) {
            case types_1.ConceptMaterialCategory.Language:
                if (conceptMaterial instanceof LanguageConceptMaterial_1.LanguageConceptMaterial) {
                    const translation = conceptMaterial.translation;
                    if (isNumber(translation)) {
                        gameplays.push(types_1.Gameplay.ComposeTheBlankWithLanguageNumberChoicesGameplay001);
                    }
                    else {
                        gameplays.push(types_1.Gameplay.FourImageChoicesGameplay002, types_1.Gameplay.ImageWithChoicesGameplay002, types_1.Gameplay.AudioWithChoicesGameplay001, types_1.Gameplay.AudioWithChoicesGameplay002, types_1.Gameplay.FourImageChoicesGameplay003, types_1.Gameplay.ImageWithChoicesGameplay003, types_1.Gameplay.TextWithChoicesGameplay001, types_1.Gameplay.TextWithChoicesGameplay002, types_1.Gameplay.FillTheBlankWithMultipleChoiceSelectionGameplay001, types_1.Gameplay.MultipleChoiceSelectionGameplay001);
                        const shortCharacterSubjectIds = ["CHINESE"];
                        if (shortCharacterSubjectIds.includes(conceptMaterial.subject.id)) {
                            gameplays.push(types_1.Gameplay.FourTextChoicesGameplay002, types_1.Gameplay.FourTextChoicesGameplay003);
                        }
                    }
                }
                break;
            case types_1.ConceptMaterialCategory.SignLanguage:
                gameplays.push(types_1.Gameplay.VideoWithChoicesGameplay002);
                break;
            default:
                break;
        }
        return gameplays;
    }
    static getSupportedGameplayDefinitions(conceptMateirals) {
        const definitions = [];
        const set = new Set();
        for (const material of conceptMateirals) {
            const gameplays = ConceptMaterialUtil.getSupportedGameplays(material);
            const allGameplayDefinitions = GameplayUtil_1.GameplayUtil.getAllGameplayDifinitions();
            const filteredGameplayDefinitions = allGameplayDefinitions
                .filter((definition) => gameplays.includes(definition.gameplay));
            for (const definition of filteredGameplayDefinitions) {
                if (!set.has(definition.gameplay)) {
                    set.add(definition.gameplay);
                    definitions.push(definition);
                }
            }
        }
        return definitions;
    }
}
exports.ConceptMaterialUtil = ConceptMaterialUtil;
